<template>
    <div>
        <div class="flex items-center justify-center text-xl font-bold text-center text-brand-blue">
            Your Call Was Completed Successfully
        </div>

        <div class="flex items-center justify-center mt-6 text-center">
            We wish you the best of luck with your case!
        </div>

        <hr class="my-8 border-b">

        <div class="mt-6 text-xs text-center text-gray-500">
            <span class="cursor-pointer text-brand-blue-light hover:text-brand-blue-dark" @click="scheduleAppointment">Schedule another appointment</span>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card');
        },

        methods: {
            scheduleAppointment() {
                this.$store.commit('modal', 'schedule-appointment');
            }
        }
    }
</script>
